import { Timestamps } from "../Timestamps";

export interface ClientUIMMMModelCurrency {
  symbol: string;
  label: string;
}

export const ClientUIMMMModelCurrencyOptions: ClientUIMMMModelCurrency[] = [
  {
    symbol: "€",
    label: "Euro"
  },
  {
    symbol: "$",
    label: "Dollar"
  },
  {
    symbol: "£",
    label: "Pound"
  },
  {
    symbol: "¥",
    label: "Yen"
  },
  {
    symbol: "Mex$",
    label: "Mexican peso"
  }
];

export const ClientUIMMMModelMetricOptions: ClientUIMMMModelMetric[] = [
  "model_accuracy",
  "mape",
  "business_error"
];

export const ClientUIMMMModelUIModulesOptions: ClientUIModule[] = [
  "modeling",
  "simulator"
];

export type ClientUIModule = "modeling" | "simulator";

export type ClientUIMMMModelMetric =
  | "model_accuracy"
  | "mape"
  | "business_error";

export interface ClientUIMMMModelConfig {
  metrics: ClientUIMMMModelMetric[];
}

export interface ClientUISimulatorConfig {}

export interface ClientShort extends Timestamps {
  id: number;
  name: string;
  label?: string;
  base_color: string;
  kpi_label: string;
}

export interface Client extends ClientCreate {
  id: number;
}

export interface ClientCreate {
  name: string;
  email: string;
  phone?: string;
  label?: string;
  logo_path: string;
  base_color: string;
  kpi_label: string;
  currency: string;
  ui_modules: ClientUIModule[];
  mmm_model_config: ClientUIMMMModelConfig;
}

export interface IClientUpdate {
  email?: string;
  phone?: string;
  label?: string;
  logo_path?: string;
  base_color?: string;
  kpi_label?: string;
  currency?: string;
  ui_modules?: ClientUIModule[];
  mmm_model_config?: ClientUIMMMModelConfig;
}
